<template>
  <!-- popup (s) -->
  <div id="messagePop" class="popWrap nowOpen">
    <span class="blind focusSet first" tabindex="0"></span>
    <div class="popup">
      <div class="popContain">
        <div class="popCont alert hasBtn" tabindex="-1" role="dialog">
          <div class="popBody">
            <div class="popInner">
              <!-- 본문 (s) -->
              <div class="msg">
                <b>시스템 점검</b>
                <br />
                <br />
                시스템 점검으로 인하여
                <br />
                모든 서비스를 이용하실수 없습니다
                <br />
                이용에 불편을 드려 죄송합니다.
              </div>
              <!-- 본문 (e) -->
            </div>
          </div>

          <div class="btnArea sticky">
            <slot name="bottomButtom">
              <button type="button" class="btn_p" @click="exit">
                확인
              </button>
            </slot>
          </div>

          <slot name="closeButton">
            <button type="button" class="btnIco_close" @click="exit">
              <span>팝업 닫기</span>
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
  <!-- popup (e) -->
</template>
<script>
export default {
  name: 'SystemCheck',
  methods: {
    exit() {
      window.exit();
    },
  },
};
</script>
